import React from "react";
import styled from "styled-components";
import colors from "../constatns/colors";
import useWindowDimensions from "../constatns/size";
import man1 from "../assets/images/man 1.png"

import "../styles/home.css";
import TeamCard from "../components/TeamCard";
import GrTitle, { Title } from "../components/BgTitle";
import { Slide } from "react-reveal";

function Team() {
    const { width, height } = useWindowDimensions();
  return (
      <div id="team">
          <GrTitle bgTitle={"CORE TEAM"} />
        <Title title={"OUR TEAM"} /> 
        <Description>The perfect team for successful implementation.</Description>
        <Container width={width} height={height} >
            <InnerContainer width={width} height={height}>
            <Slide left>
                <TeamCard
                    // image={globe}
                    title={"Harry SY Jung"}
                    description={"Founder & Project Lead"}
                    href={"https://www.linkedin.com/in/harryjung/"}
                />
            </Slide>
            <Slide left>
                <TeamCard
                    // image={man1}
                    title={"Mahmood Ur Rehman"}
                    description={"Developer"}
                    href={"https://www.linkedin.com/in/mahmood-ur-rehman-795116145/"}
                />
            </Slide>
            </InnerContainer>
            <InnerContainer width={width} height={height}>
            <Slide right>
                <TeamCard
                    image={man1}
                    title={"Bona Yi"}
                    description={"Designer"}
                />
            </Slide>
            <Slide right>
                <TeamCard
                    image={man1}
                    title={"Pooja Ph Hegde"}
                    description={"Legal & Advisor"}
                    href={"https://www.linkedin.com/in/hegde-pooja/"}
                />
            </Slide>
            </InnerContainer>
            <InnerContainer width={width} height={height}>
            <Slide left>
                <TeamCard
                    image={man1}
                    title={"Wisdom Oparaocha"}
                    href={"https://www.linkedin.com/in/wisdom-oparaocha/"}
                    description={"Developer & Advisor"}
                />
            </Slide>
            <Slide left>
                <TeamCard
                    image={man1}
                    title={"Kelly McCoy"}
                    description={"Partner & Advisor"}
                    href={"https://www.linkedin.com/in/mkellymccoy/"}
                />
            </Slide>
            </InnerContainer>
            <InnerContainer width={width} height={height}>
            <Slide right>
                <TeamCard
                    image={man1}
                    title={"Ibrahim Mataan"}
                    href={"https://www.linkedin.com/in/ibrahim-mataan-356842222/"}
                    description={"Product Advisor"}
                />
            </Slide>
            <Slide right>
                <TeamCard
                    image={man1}
                    title={"L Mario Mascioli"}
                    description={"General Manager"}
                    href={"https://www.linkedin.com/in/lmariomascioli/"}
                />
            </Slide>
            </InnerContainer>
            <InnerContainer width={width} height={height}>
            <Slide left>
                <TeamCard
                    image={man1}
                    title={"Chandrahas Singh"}
                    href={"https://www.linkedin.com/in/kevinbrooke/"}
                    description={"Chief Development Officer"}
                />
            </Slide>           
            </InnerContainer>
        </Container>
    </div>
  );
}

const Container = styled.div`
    /* display: flex; */
    padding-left: ${({width})=> width * 0.1}px;
    padding-right: ${({width})=> width * 0.1}px;
    padding-bottom: 50px;

    
`

const InnerContainer = styled.div`
    display: flex;
    padding-left: ${({width})=> width * 0.05}px;
    /* padding-right: ${({width})=> width * 0.1}px; */
    margin-top: ${({height})=> height * 0.05}px ;
    justify-content: space-between;
    color: ${colors.white};
    width: 90%;

    @media (max-width: 768px) {
        display: block;
        width: 100%;
        margin-top: 0px ;
    }

    

`

const Description = styled.p`
    color: ${colors.grey};
    text-align: center;
`

export default Team;
